module.exports = __webpack_public_path__ + "static/img/21.03cbab1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/21.png
// module id = 3oyi
// module chunks = 0